import { z } from 'zod';
import { fromError, isZodErrorLike } from 'zod-validation-error';
export type ErrorsMap<T> = {
    [K in keyof T]?: string;
};
export class FormService {
    static validate<TValues extends object, T extends z.ZodObject = z.ZodObject>(
        values: TValues,
        schema: T
    ): { valid: boolean; errorsMap: ErrorsMap<TValues> } {
        try {
            schema.parse(values);
            return { valid: true, errorsMap: {} };
        } catch (e: unknown) {
            if (isZodErrorLike(e)) {
                const zodError = fromError(e);
                const errorsMap: ErrorsMap<TValues> = {};
                zodError.details.forEach((detail) => {
                    const field = detail.path[0] as keyof TValues;
                    if (!errorsMap[field]) errorsMap[field] = detail.message;
                });
                return { valid: false, errorsMap };
            }
            throw e;
        }
    }

    
    static appendToFormData(fd: FormData, key: string, value: unknown) {
        if (value === null || value === undefined) return;

        if (Array.isArray(value)) {
            value.forEach((item) => FormService.appendToFormData(fd, key, item));
            return;
        }

        if (value instanceof Blob) {
            fd.append(key, value);
        } else {
            fd.append(key, String(value));
        }
    }

    static toFormData<T extends Record<string, unknown>>(dto: T): FormData {
        const fd = new FormData();
        Object.entries(dto).forEach(([k, v]) => {
            FormService.appendToFormData(fd, k, v);
        });
        return fd;
    }
}
